<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/MTMonthly'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCode'"
                    :name="'reAgentCode'"
                    :select2-options="reAgentCodeOptions"
                    v-model="reAgentCode"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="MTMonthlyTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="14">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center" style="min-width:150px">
                      อาการเสีย
                    </th>
                    <th class="all text-center" style="min-width:150px">
                      อาการเสีย (อื่นๆ)
                    </th>
                    <th class="all text-center" style="min-width:150px">
                      สาเหตุของปัญหา
                    </th>
                    <th class="all text-center" style="min-width:150px">
                      วิธีการแก้ไข
                    </th>
                    <th class="all text-center">
                      รหัสบาร์โค้ด เครื่องเบียร์สด
                    </th>
                    <th class="all text-center">
                      รหัสบาร์โค้ดเก่า เครื่องเบียร์สด
                    </th>
                    <th class="all text-center">รหัสบาร์โค้ด หัวจ่าย</th>
                    <th class="all text-center">รหัสบาร์โค้ดเก่า หัวจ่าย</th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reAgentCode: null,
      reIsInitial: true,
      reAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reAgentCode = null;

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      $("#reAgentCode")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#MTMonthlyTable").DataTable();
      table.draw();
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#MTMonthlyTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/MTMonthly",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              StartDate:
                self.reStartDate != null
                  ? self.reStartDate.format("DD/MM/YYYY")
                  : self.reStartDate,
              EndDate:
                self.reEndDate != null
                  ? self.reEndDate.format("DD/MM/YYYY")
                  : self.reEndDate,
              AgentCode: self.reAgentCode,
              IsInitial: self.reIsInitial,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[2, "desc"]],
        columns: [
          {
            data: "mtDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "agentName", className: "text-center" },
          {
            data: "mtDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.mtDateString;
            },
          },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          { data: "failureMachine", className: "text-left text-wrap" },
          { data: "failureMachineOther", className: "text-left text-wrap" },
          { data: "failureMachineReason", className: "text-left text-wrap" },
          { data: "resolve", className: "text-left text-wrap" },
          {
            data: "machine",
            className: "text-center",
            render: function(data, type, full, meta) {
              //console.log(data);
              if (data != null) {
                return data.machineBarcode;
              } else return "";
            },
          },
          {
            data: "machine",
            className: "text-center",
            render: function(data, type, full, meta) {
              //console.log(data);
              if (data != null) {
                return data.machineBarcodeOld;
              } else return "";
            },
          },
          {
            data: "dispenser",
            className: "text-center",
            render: function(data, type, full, meta) {
              //console.log(data);
              if (data != null) {
                return data.dispenserBarcode;
              } else return "";
            },
          },
          {
            data: "dispenser",
            className: "text-center",
            render: function(data, type, full, meta) {
              //console.log(data);
              if (data != null) {
                return data.dispenserBarcodeOld;
              } else return "";
            },
          },
        ],
        drawCallback: function(settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/MTMonthly.vue